import React from "react";
import { MockupSlot } from "./MockupSlot";
import { activityPages } from "../data/landing";
export function ActivityBookSection() {
  return <section className="bg-sage-light" data-id="element-1" data-mp="3pfsvdfhmmg5x">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 py-16 md:py-24 lg:grid-cols-2 lg:gap-16" data-id="element-2" data-mp="3bncykwfbjedg">
        <div data-id="element-3" data-mp="3fnwuxxs2idyj">
          <h2 className="font-display text-3xl font-bold uppercase leading-tight text-sage-deep md:text-[2.6rem]" data-id="element-4" data-mp="3fpq1ze6lf072">
            Le Grand Cahier d’Activités Bibliques
          </h2>
          <p className="mt-4 font-display text-xl italic text-ink md:text-2xl" data-id="element-5" data-mp="c8hkivfs22cv">
            Parce que les enfants apprennent aussi en jouant, en dessinant et en
            partageant.
          </p>
          <p className="mt-5 leading-relaxed text-ink-soft md:text-lg" data-id="element-6" data-mp="36rtvrtpz7g5">
            Prolongez les enseignements des paraboles avec des activités à
            imprimer, pensées pour encourager la réflexion, l’expression des
            émotions et les échanges en famille.
          </p>
          <p className="mt-8 rounded-2xl bg-cream px-6 py-5 font-display text-lg font-semibold leading-snug text-ink md:text-xl" data-id="element-7" data-mp="1sgjzpvercww">
            Lisez une parabole, découvrez sa leçon et continuez à explorer son
            message ensemble.
          </p>
        </div>

        <div data-id="element-8" data-mp="botg0uefe2ut">
          <div className="grid grid-cols-3 gap-3 md:gap-4" data-id="element-9" data-mp="6rt80dy0mq12">
            {activityPages.map((page, i) => <MockupSlot key={i} src={page.src} label={page.title} hint="Bientôt disponible" className="aspect-[3/4] w-full bg-cream/70 p-2" data-id="element-10" data-mp="krb1v7q64tha" data-mpi={i} />)}
          </div>
          <p className="mt-4 text-center text-sm text-ink-soft" data-id="element-11" data-mp="ugmayud21y56">
            Aperçu des pages du cahier présenté dès leur finalisation.
          </p>
        </div>
      </div>
    </section>;
}